import { Injectable, ɵɵdefineInjectable, ɵɵinject, Injector, NgModule } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, tap, map, switchMap, take } from 'rxjs/operators';
import { ApiService, ConfigService } from 'shaman-utils';
import { Router } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShamanAuthService extends ApiService {
    /**
     * @param {?} http
     * @param {?} configService
     */
    constructor(http, configService) {
        super(http);
        this.isLoggedInSubject = new BehaviorSubject(false);
        this.isLoggedIn = this.isLoggedInSubject.asObservable();
        this.authenticationFailedSubject = new BehaviorSubject(false);
        this.authenticationFailed = this.authenticationFailedSubject.asObservable();
        this.validateAccessToken = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            let token = this.storage.getItem('accessToken');
            /** @type {?} */
            let passportString = this.storage.getItem('passport');
            if (!token || !passportString)
                return false;
            /** @type {?} */
            let passport = JSON.parse(passportString);
            if (Date.parse(passport.accessTokenExpires) < Date.parse(String(new Date())))
                return false;
            return true;
        });
        this.validateRefreshToken = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            let token = this.storage.getItem('refreshToken');
            /** @type {?} */
            let passportString = this.storage.getItem('passport');
            if (!token || !passportString)
                return false;
            /** @type {?} */
            let passport = JSON.parse(passportString);
            if (Date.parse(passport.refreshTokenExpires) < Date.parse(String(new Date())))
                return false;
            return true;
        });
        this.login = (/**
         * @param {?} email
         * @param {?} pwd
         * @return {?}
         */
        (email, pwd) => {
            this.post('/auth/login', { email: email, pwd: pwd })
                .subscribe((/**
             * @param {?} rslt
             * @return {?}
             */
            (rslt) => {
                this.storeTokens(rslt);
                this.isLoggedInSubject.next(true);
            }), (/**
             * @param {?} _
             * @return {?}
             */
            _ => this.authenticationFailedSubject.next(true)));
        });
        this.refreshAccessToken = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            let data = { refreshToken: this.storage.getItem('refreshToken') };
            return this.post('/auth/refresh', data)
                .pipe(catchError((/**
             * @param {?} error
             * @return {?}
             */
            error => {
                this.authenticationFailedSubject.next(true);
                return throwError(error);
            })), tap((/**
             * @param {?} rslt
             * @return {?}
             */
            (rslt) => {
                this.storeTokens(rslt);
                this.isLoggedInSubject.next(true);
            })));
        });
        this.storeTokens = (/**
         * @param {?} rslt
         * @return {?}
         */
        (rslt) => {
            this.storage.setItem('accessToken', rslt.accessToken);
            this.storage.setItem('refreshToken', rslt.refreshToken);
            this.storage.setItem('passport', JSON.stringify({
                userId: rslt.userId,
                emailAddress: rslt.emailAddress,
                firstName: rslt.firstName,
                lastName: rslt.lastName,
                accessTokenExpires: rslt.accessTokenExpires,
                refreshTokenExpires: rslt.refreshTokenExpires
            }));
        });
        this.storage = window.localStorage;
        if (this.validateAccessToken())
            this.isLoggedInSubject.next(true);
        this.apiBaseUri = configService.currentConfiguration.pipe(map((/**
         * @param {?} config
         * @return {?}
         */
        config => config.apiBaseUri)));
    }
    /**
     * @return {?}
     */
    get passport() {
        /** @type {?} */
        let passportString = this.storage.getItem('passport');
        if (!passportString)
            return null;
        /** @type {?} */
        let passport = JSON.parse(passportString);
        return passport;
    }
}
ShamanAuthService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ShamanAuthService.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];
/** @nocollapse */ ShamanAuthService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ShamanAuthService_Factory() { return new ShamanAuthService(ɵɵinject(HttpClient), ɵɵinject(ConfigService)); }, token: ShamanAuthService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @protected
     */
    ShamanAuthService.prototype.apiBaseUri;
    /**
     * @type {?}
     * @protected
     */
    ShamanAuthService.prototype.isLoggedInSubject;
    /** @type {?} */
    ShamanAuthService.prototype.isLoggedIn;
    /**
     * @type {?}
     * @protected
     */
    ShamanAuthService.prototype.authenticationFailedSubject;
    /** @type {?} */
    ShamanAuthService.prototype.authenticationFailed;
    /** @type {?} */
    ShamanAuthService.prototype.storage;
    /** @type {?} */
    ShamanAuthService.prototype.validateAccessToken;
    /** @type {?} */
    ShamanAuthService.prototype.validateRefreshToken;
    /** @type {?} */
    ShamanAuthService.prototype.login;
    /** @type {?} */
    ShamanAuthService.prototype.refreshAccessToken;
    /**
     * @type {?}
     * @private
     */
    ShamanAuthService.prototype.storeTokens;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthInterceptor {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        this.injector = injector;
        this.getAuthService = (/**
         * @return {?}
         */
        () => {
            if (!this.authService) {
                this.authService = this.injector.get(ShamanAuthService);
            }
            return this.authService;
        });
        this.makeRequestWithAccessToken = (/**
         * @param {?} accessToken
         * @param {?} request
         * @param {?} next
         * @return {?}
         */
        (accessToken, request, next) => {
            /** @type {?} */
            let passport = JSON.parse(this.storage.getItem('passport'));
            return next.handle(this.addTokens(request, accessToken, passport))
                .pipe(catchError((/**
             * @param {?} error
             * @return {?}
             */
            error => {
                return this.handleAccessTokenError(error, request, next);
            })));
        });
        this.makeRequestWithRefreshToken = (/**
         * @param {?} request
         * @param {?} next
         * @return {?}
         */
        (request, next) => {
            /** @type {?} */
            let passport = JSON.parse(this.storage.getItem('passport'));
            return this.authService.refreshAccessToken()
                .pipe(switchMap((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                let accessToken = this.storage.getItem('accessToken');
                return next.handle(this.addTokens(request, accessToken, passport));
            })));
        });
        this.handleAccessTokenError = (/**
         * @param {?} error
         * @param {?} request
         * @param {?} next
         * @return {?}
         */
        (error, request, next) => {
            if ((/** @type {?} */ (error)) instanceof HttpErrorResponse || error.status != 401)
                return throwError(error);
            /** @type {?} */
            let authService = this.getAuthService();
            if (!authService.validateRefreshToken())
                return throwError(error);
            return this.makeRequestWithRefreshToken(request, next);
        });
        this.addTokens = (/**
         * @param {?} request
         * @param {?} token
         * @param {?} passport
         * @return {?}
         */
        (request, token, passport) => {
            request = request.clone({
                setHeaders: {
                    'authorization': `${token}`,
                    'x-user-email': passport.emailAddress
                }
            });
            return request;
        });
        this.storage = window.localStorage;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        if (request.url.match(/.json/i)) {
            return next.handle(request);
        }
        if (request.url.match('/auth/')) {
            return next.handle(request);
        }
        /** @type {?} */
        let authService = this.getAuthService();
        if (authService.validateAccessToken()) {
            /** @type {?} */
            let accessToken = this.storage.getItem('accessToken');
            return this.makeRequestWithAccessToken(accessToken, request, next);
        }
        if (authService.validateRefreshToken()) {
            return this.makeRequestWithRefreshToken(request, next);
        }
    }
}
AuthInterceptor.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthInterceptor.ctorParameters = () => [
    { type: Injector }
];
if (false) {
    /** @type {?} */
    AuthInterceptor.prototype.storage;
    /**
     * @type {?}
     * @private
     */
    AuthInterceptor.prototype.authService;
    /**
     * @type {?}
     * @private
     */
    AuthInterceptor.prototype.getAuthService;
    /** @type {?} */
    AuthInterceptor.prototype.makeRequestWithAccessToken;
    /** @type {?} */
    AuthInterceptor.prototype.makeRequestWithRefreshToken;
    /** @type {?} */
    AuthInterceptor.prototype.handleAccessTokenError;
    /**
     * @type {?}
     * @private
     */
    AuthInterceptor.prototype.addTokens;
    /**
     * @type {?}
     * @private
     */
    AuthInterceptor.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShamanAuthGuard {
    /**
     * @param {?} router
     * @param {?} authService
     */
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
        this.canActivate = (/**
         * @param {?} _a
         * @param {?} _b
         * @return {?}
         */
        (_a, _b) => {
            return this.authService.isLoggedIn
                .pipe(take(1), tap((/**
             * @param {?} isLoggedIn
             * @return {?}
             */
            isLoggedIn => {
                if (!isLoggedIn) {
                    this.router.navigate(['login']);
                }
            })));
        });
    }
}
ShamanAuthGuard.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ShamanAuthGuard.ctorParameters = () => [
    { type: Router },
    { type: ShamanAuthService }
];
if (false) {
    /** @type {?} */
    ShamanAuthGuard.prototype.canActivate;
    /**
     * @type {?}
     * @private
     */
    ShamanAuthGuard.prototype.router;
    /**
     * @type {?}
     * @private
     */
    ShamanAuthGuard.prototype.authService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShamanPassport {
}
if (false) {
    /** @type {?} */
    ShamanPassport.prototype.userId;
    /** @type {?} */
    ShamanPassport.prototype.emailAddress;
    /** @type {?} */
    ShamanPassport.prototype.firstName;
    /** @type {?} */
    ShamanPassport.prototype.lastName;
    /** @type {?} */
    ShamanPassport.prototype.authToken;
    /** @type {?} */
    ShamanPassport.prototype.authTokenExpires;
    /** @type {?} */
    ShamanPassport.prototype.refreshToken;
    /** @type {?} */
    ShamanPassport.prototype.refreshTokenExpires;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShamanAuthModule {
}
ShamanAuthModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                providers: [ShamanAuthService, ShamanAuthGuard],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AuthInterceptor, ShamanAuthGuard, ShamanAuthModule, ShamanAuthService, ShamanPassport };
//# sourceMappingURL=shaman-auth.js.map
